
<template>
  <div class="video-report-component">
    <el-card shadow="never" class="report-card">
      <div slot="header" class="card-header">
        <span><i class="el-icon-data-analysis"></i> 视频消耗报表</span>
        <div class="header-actions">
          <el-button-group>
            <el-button
                size="small"
                :type="viewMode === 'table' ? 'primary' : ''"
                icon="el-icon-s-grid"
                @click="viewMode = 'table'"
            >
              表格视图
            </el-button>
            <el-button
                size="small"
                :type="viewMode === 'grid' ? 'primary' : ''"
                icon="el-icon-menu"
                @click="viewMode = 'grid'"
            >
              卡片视图
            </el-button>
            <el-button
                size="small"
                :type="viewMode === 'thumbnail' ? 'primary' : ''"
                icon="el-icon-picture"
                @click="viewMode = 'thumbnail'"
            >
              缩略图
            </el-button>
          </el-button-group>
          <el-button type="primary" size="small" icon="el-icon-refresh" @click="fetchReportData" :loading="loading">
            刷新数据
          </el-button>
        </div>
      </div>

      <!-- 表格视图 -->
      <el-form v-if="viewMode === 'table'" :inline="true" class="filter-form">


        <el-form-item label="日期范围">
          <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width: 240px"
          />
        </el-form-item>

        <el-form-item label="排序字段">
          <el-select v-model="queryParams.sortField" style="width: 150px">
            <el-option label="消耗" value="spend" />
            <el-option label="展示数" value="impressions" />
            <el-option label="点击数" value="clicks" />
          </el-select>
        </el-form-item>

        <el-form-item label="排序方式">
          <el-select v-model="queryParams.sortType" style="width: 120px">
            <el-option label="降序" value="DESC" />
            <el-option label="升序" value="ASC" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearch"
            :loading="loading"
            :disabled="!canSearch"
          >
            查询
          </el-button>
          <el-button @click="handleReset" :disabled="loading">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 卡片视图筛选栏 -->
      <el-form v-else :inline="true" class="filter-form">
        <el-form-item label="日期范围">
          <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width: 240px"
          />
        </el-form-item>

        <el-form-item label="排序字段">
          <el-select v-model="queryParams.sortField" style="width: 150px" @change="handleSortChange">
            <el-option label="消耗" value="spend" />
            <el-option label="展示数" value="impressions" />
            <el-option label="点击数" value="clicks" />
            <el-option label="点击率" value="ctr" />
          </el-select>
        </el-form-item>

        <el-form-item label="排序方式">
          <el-select v-model="queryParams.sortType" style="width: 120px" @change="handleSortChange">
            <el-option label="降序" value="DESC" />
            <el-option label="升序" value="ASC" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格视图 -->
      <el-table
          v-if="viewMode === 'table'"
          :data="reportData"
          v-loading="loading"
          stripe
          border
          style="width: 100%"
          row-key="info.material_id"
          ref="reportTable"
          @selection-change="handleSelectionChange"
      >

        <el-table-column type="selection" width="55" align="center" :reserve-selection="true" :selectable="checkSelectable" />

        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tooltip
              v-if="!row.imageId && !row.coverUrl"
              content="缺少封面ID，可能无法正常使用"
              placement="top"
            >
              <el-tag size="mini" type="warning" effect="plain">
                <i class="el-icon-warning"></i> 无封面
              </el-tag>
            </el-tooltip>
            <el-tag v-else size="mini" type="success" effect="plain">
              <i class="el-icon-check"></i> 正常
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="序号" type="index" width="60" align="center" />

        <el-table-column label="视频ID" prop="video_id" min-width="160">
          <template slot-scope="{ row }">
            <div class="id-cell">
              <el-tooltip :content="row.info.material_id" placement="top">
                <span class="id-text">{{ row.info.material_id }}</span>
              </el-tooltip>
              <i
                  class="el-icon-document-copy copy-icon"
                  @click="copyToClipboard(row.info.material_id)"
              ></i>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="视频名称" prop="info.material_name" min-width="200" show-overflow-tooltip />

        <el-table-column label="视频预览" width="150" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.videoPreview" class="video-preview-cell">
              <video
                  :src="row.videoPreview"
                  controls                style="width: 120px; height: 80px; border-radius: 4px;"
              ></video>
            </div>
            <div v-else-if="row.coverUrl" class="cover-preview-cell">
              <img
                  :src="row.coverUrl"
                  alt="视频封面"      style="width: 120px; height: 80px; border-radius: 4px; object-fit: cover;"
              />
            </div>
            <span v-else class="no-preview">-</span>
          </template>
        </el-table-column>

        <el-table-column label="创建时间" width="180" >
          <template slot-scope="{ row }">
            {{ formatBeijingTime(row.info.create_time)}}
          </template>
        </el-table-column>
        <el-table-column label="消耗(元)" prop="metrics.spend" width="120" align="right" >
          <template slot-scope="{ row }">
            <span class="amount-text">¥{{ formatNumber(row.metrics.spend) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="展示数" prop="show_cnt" width="120" align="right" >
          <template slot-scope="{ row }">
            {{ formatNumber(row.metrics.impressions) }}
          </template>
        </el-table-column>

        <el-table-column label="点击数" prop="click_cnt" width="120" align="right" >
          <template slot-scope="{ row }">
            {{ formatNumber(row.metrics.clicks) }}
          </template>
        </el-table-column>

        <el-table-column label="点击率" width="100" align="right">
          <template slot-scope="{ row }">
            {{ calculateCTR(row.metrics.clicks, row.metrics.impressions) }}%
          </template>
        </el-table-column>
      </el-table>

      <!-- 卡片视图 -->
      <div v-else-if="viewMode === 'grid'" v-loading="loading" class="grid-view">
        <div class="video-grid">
          <div
              v-for="(item, index) in sortedReportData"
              :key="(item.info && item.info.material_id) || index"
              class="video-card"
              :class="{ 'selected': isVideoSelected(item) }"
              @click="toggleCardSelection(item)"
          >
            <div class="card-checkbox">
              <el-checkbox
                  :value="isVideoSelected(item)"
                  @click.native.stop
                  @change="toggleCardSelection(item)"
                  :disabled="!item.imageId && !item.coverUrl"
              ></el-checkbox>
            </div>

            <!-- 缺少封面ID提示 -->
            <div class="missing-badge" v-if="!item.imageId && !item.coverUrl">
              <el-tag size="mini" type="warning" effect="dark">
                <i class="el-icon-warning"></i> 无封面
              </el-tag>
            </div>

            <div class="card-video-preview">
              <video
                  v-if="item.videoPreview"
                  :src="item.videoPreview"
                  controls
                  @click.stop
              ></video>
              <img
                  v-else-if="item.coverUrl"
                  :src="item.coverUrl"
                  alt="视频封面"
                  @click.stop
              />
              <div v-else class="no-preview-placeholder">
                <i class="el-icon-video-camera"></i>
                <span>无预览</span>
              </div>
            </div>

            <div class="card-info">
              <el-tooltip :content="item.info ? item.info.material_name : ''" placement="top">
                <div class="card-name">{{ (item.info && item.info.material_name) || '未命名' }}</div>
              </el-tooltip>

              <div class="card-metrics">
                <div class="metric-item">
                  <span class="metric-label">消耗:</span>
                  <span class="metric-value amount">${{ formatNumber(item.metrics ? item.metrics.spend : 0) }}</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">展示:</span>
                  <span class="metric-value">{{ formatNumber(item.metrics ? item.metrics.impressions : 0) }}</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">点击:</span>
                  <span class="metric-value">{{ formatNumber(item.metrics ? item.metrics.clicks : 0) }}</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">点击率:</span>
                  <span class="metric-value">{{ calculateCTR(item.metrics ? item.metrics.clicks : 0, item.metrics ? item.metrics.impressions : 0) }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <el-empty v-if="!loading && reportData.length === 0" description="暂无数据" />
      </div>

      <!-- 缩略图视图 -->
      <div v-else-if="viewMode === 'thumbnail'" v-loading="loading" class="thumbnail-view">
        <div class="thumbnail-grid">
          <div
              v-for="(item, index) in sortedReportData"
              :key="(item.info && item.info.material_id) || index"
              class="thumbnail-item"
              :class="{ 'selected': isVideoSelected(item), 'disabled': !item.imageId && !item.coverUrl }"
              @click="handleThumbnailClick(item)"
          >
            <!-- 选择框 -->
            <div class="thumbnail-checkbox">
              <el-checkbox
                  :value="isVideoSelected(item)"
                  :disabled="!item.imageId && !item.coverUrl"
                  @click.native.stop
                  @change="toggleCardSelection(item)"
              ></el-checkbox>
            </div>

            <!-- 缺少封面提示 -->
            <div class="thumbnail-missing-badge" v-if="!item.imageId && !item.coverUrl">
              <i class="el-icon-warning"></i>
            </div>

            <!-- 视频/封面预览 -->
            <div class="thumbnail-preview">
              <video
                  v-if="item.videoPreview"
                  :src="item.videoPreview"
                  preload="metadata"
                  muted
                  @mouseenter="handleVideoHover($event, true)"
                  @mouseleave="handleVideoHover($event, false)"
                  @click.stop
              ></video>
              <img
                  v-else-if="item.coverUrl"
                  :src="item.coverUrl"
                  alt="视频封面"
                  @click.stop
              />
              <div v-else class="no-thumbnail-placeholder">
                <i class="el-icon-video-camera"></i>
              </div>

              <!-- 播放图标遮罩 -->
              <div class="play-overlay" v-if="item.videoPreview">
                <i class="el-icon-video-play"></i>
              </div>
            </div>

            <!-- 简要信息 -->
            <div class="thumbnail-info">
              <el-tooltip :content="(item.info && item.info.material_name) || '未命名'" placement="top">
                <div class="thumbnail-name">{{ truncate((item.info && item.info.material_name) || '未命名', 20) }}</div>
              </el-tooltip>
              <div class="thumbnail-metrics">
                <span class="metric-spend">¥{{ formatNumber(item.metrics ? item.metrics.spend : 0) }}</span>
              </div>
            </div>
          </div>
        </div>

        <el-empty v-if="!loading && reportData.length === 0" description="暂无数据" />
      </div>

      <div class="table-actions" v-if="selectedVideos.length > 0">
        <el-alert
            :title="`已选择 ${selectedVideos.length} 个视频`"
            type="info"
            :closable="false"
            show-icon
        />
        <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="addToLibrary"
        >
          添加到素材库
        </el-button>
      </div>

      <div class="pagination-container">
        <el-pagination
            background
            :current-page="queryParams.page"
            :page-size="queryParams.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
        />
      </div>
    </el-card>
  </div>
</template>


<script>
import axios from 'axios'
import { videoApi } from '@/api/ad'

export default {
  name: 'VideoReport',
  props: {

  },
  data() {
    return {
      loading: false,
      viewMode: 'grid', // 'table' 或 'grid'
      reportData: [],
      total: 0,
      dateRange: [],
      selectedVideos: [],
      selectedVideoMap: new Map(), // 使用 Map 存储所有选中的视频，key 为 video_id
      queryParams: {
        advertiserId: '',
        reportType: 'VIDEO_INSIGHT',
        startDate: '',
        endDate: '',
        sortField: 'spend',
        sortType: 'DESC',
        page: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    canSearch() {
      return this.dateRange && this.dateRange.length === 2
    },

    sortedReportData() {
      if (!this.reportData || this.reportData.length === 0) {
        return []
      }

      const { sortField, sortType } = this.queryParams
      const multiplier = sortType === 'DESC' ? -1 : 1

      return [...this.reportData].sort((a, b) => {
        let aValue, bValue

        switch (sortField) {
          case 'spend':
            aValue = parseFloat((a.metrics && a.metrics.spend) || 0)
            bValue = parseFloat((b.metrics && b.metrics.spend) || 0)
            break
          case 'impressions':
            aValue = parseInt((a.metrics && a.metrics.impressions) || 0)
            bValue = parseInt((b.metrics && b.metrics.impressions) || 0)
            break
          case 'clicks':
            aValue = parseInt((a.metrics && a.metrics.clicks) || 0)
            bValue = parseInt((b.metrics && b.metrics.clicks) || 0)
            break
          case 'ctr':
            aValue = this.calculateCTRValue(a.metrics ? a.metrics.clicks : 0, a.metrics ? a.metrics.impressions : 0)
            bValue = this.calculateCTRValue(b.metrics ? b.metrics.clicks : 0, b.metrics ? b.metrics.impressions : 0)
            break
          default:
            aValue = parseFloat((a.metrics && a.metrics.spend) || 0)
            bValue = parseFloat((b.metrics && b.metrics.spend) || 0)
        }

        return (aValue - bValue) * multiplier
      })
    }
  },
  watch: {
    // advertiserId: {
    //   immediate: true,
    //   handler(newVal) {
    //     if (newVal) {
    //       this.queryParams.advertiserId = newVal
    //       this.fetchReportData()
    //     }
    //   }
    // }
  },
  mounted() {
    this.initDefaultDateRange()
  },
  methods: {
    initDefaultDateRange() {
      const end = new Date()
      const start = new Date()
      start.setDate(start.getDate() - 7)

      this.dateRange = [
        this.formatDate(start),
        this.formatDate(end)
      ]

      this.queryParams.startDate = this.dateRange[0]
      this.queryParams.endDate = this.dateRange[1]
    },

    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    handleSearch() {
      if (!this.canSearch) {
        this.$message.warning('请选择日期范围')
        return
      }

      if (this.loading) {
        this.$message.info('数据加载中，请稍候...')
        return
      }

      const [startDate, endDate] = this.dateRange

      const start = new Date(startDate)
      const end = new Date(endDate)
      const diffDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24))

      if (diffDays > 90) {
        this.$message.warning('日期范围不能超过90天')
        return
      }

      if (start > end) {
        this.$message.warning('开始日期不能晚于结束日期')
        return
      }

      this.queryParams.startDate = startDate
      this.queryParams.endDate = endDate
      this.queryParams.page = 1
      this.fetchReportData()
    },

    handleReset() {
      this.initDefaultDateRange()
      this.queryParams.sortField = 'spend'
      this.queryParams.sortType = 'DESC'
      this.queryParams.page = 1
      this.fetchReportData()
    },

    handleSortChange() {
      // 卡片视图中排序字段改变时触发重新排序
      // 由于使用了 computed，会自动重新计算
    },

    async fetchReportData() {

      if (!this.queryParams.startDate || !this.queryParams.endDate) {
        this.$message.warning('请选择日期范围')
        return
      }

      this.loading = true
      try {
        const response = await axios.get('https://tiktoktf.darknight.games/api/app/creative/report', {
          params: this.queryParams,
          withCredentials: false,
          headers: {
            'User-Agent': 'Apifox/1.0.0 (https://apifox.com)'
          }
        })

        if (response.data && response.data.code === 200) {
          this.reportData = response.data.data.data?.list || []
          this.total = response.data.data.data?.page_info?.total_number || 0

          // 获取每个视频的预览信息
          await this.fetchVideoPreviews()

          // 恢复之前页面的选中状态
          this.$nextTick(() => {
            this.restoreSelection()
          })
        } else {
          this.$message.error(response.data?.message || '获取数据失败')
        }
      } catch (error) {
        console.error('获取视频消耗报表失败', error)
        this.$message.error('获取数据失败：' + (error.message || '网络错误'))
      } finally {
        this.loading = false
      }
    },
    restoreSelection() {
      if (!this.$refs.reportTable) return

      this.reportData.forEach(row => {
        const videoId = row.info ? row.info.material_id : null
        if (videoId && this.selectedVideoMap.has(videoId)) {
          this.$refs.reportTable.toggleRowSelection(row, true)
        }
      })
    },
    async fetchVideoPreviews() {
      if (!this.reportData || this.reportData.length === 0) {
        return
      }

      // 批量获取视频预览信息
      const promises = this.reportData.map(async (item) => {
        try {
          const res = await videoApi.search({
            advertiserId: "7598883753192357896",
            videoName: (item.info && item.info.material_name) || '',
            page: 1,
            pageSize: 1
          })

          if (res.code === 200 && res.data && res.data.length > 0) {
            const videoInfo = res.data[0]

            // 设置视频预览URL
            this.$set(item, 'videoPreview', videoInfo.preview_url || '')

            // 设置封面URL
            this.$set(item, 'coverUrl', videoInfo.video_cover_url || '')

            // 设置视频ID
            this.$set(item, 'videoId', videoInfo.video_id || '')

            // 设置视频ID
            this.$set(item, 'imageId', videoInfo.image_id || '')
          }
        } catch (error) {
          console.error(`获取视频 ${item.video_id} 预览失败`, error)
        }
      })

      // 等待所有请求完成
      await Promise.all(promises)
    },

    handlePageChange(page) {
      this.queryParams.page = page
      this.fetchReportData()
    },

    handleSizeChange(size) {
      this.queryParams.pageSize = size
      this.queryParams.page = 1
      this.fetchReportData()
    },

    formatNumber(num) {
      if (num === null || num === undefined) return '0'
      return Number(num).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },

    calculateCTR(clicks, impressions) {
      if (!impressions || impressions === 0) return '0.00'
      const ctr = (clicks / impressions) * 100
      return ctr.toFixed(2)
    },

    calculateCTRValue(clicks, impressions) {
      if (!impressions || impressions === 0) return 0
      return (clicks / impressions) * 100
    },

    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$message.success('已复制到剪贴板')
      }).catch(() => {
        this.$message.error('复制失败')
      })
    },

    truncate(str, len) {
      if (!str) return ''
      return str.length > len ? str.substring(0, len) + '...' : str
    },

    formatBeijingTime(utcTime) {
      if (!utcTime) return '-'

      const date = new Date(utcTime)

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    handleSelectionChange(selection) {
      // 获取当前页的视频 ID 列表
      const currentPageIds = this.reportData.map(item => item.info ? item.info.material_id : null)

      // 移除当前页中未选中的视频
      currentPageIds.forEach(id => {
        if (!selection.find(item => (item.info && item.info.material_id) === id)) {
          this.selectedVideoMap.delete(id)
        }
      })

      // 添加当前页新选中的视频
      selection.forEach(item => {
        this.selectedVideoMap.set(item.info ? item.info.material_id : null, item)
      })

      // 更新 selectedVideos 为所有选中的视频
      this.selectedVideos = Array.from(this.selectedVideoMap.values())
    },

    isVideoSelected(item) {
      const videoId = item.info ? item.info.material_id : null
      return videoId && this.selectedVideoMap.has(videoId)
    },

    toggleCardSelection(item) {
      const videoId = item.info ? item.info.material_id : null
      if (!videoId) return

      if (!item.imageId && !item.coverUrl) {
        this.$message.warning('该视频缺少封面信息，建议不要选择')
      }

      if (this.selectedVideoMap.has(videoId)) {
        this.selectedVideoMap.delete(videoId)
      } else {
        this.selectedVideoMap.set(videoId, item)
      }

      this.selectedVideos = Array.from(this.selectedVideoMap.values())
    },

    checkSelectable(row) {
      return !!(row.imageId || row.coverUrl)
    },

    handleThumbnailClick(item) {
      if (!item.imageId && !item.coverUrl) {
        this.$message.warning('该视频缺少封面信息，无法选择')
        return
      }
      this.toggleCardSelection(item)
    },

    handleVideoHover(event, isEnter) {
      const video = event.target
      if (isEnter) {
        video.play().catch(() => {
          // 自动播放失败时静默处理
        })
      } else {
        video.pause()
        video.currentTime = 0
      }
    },

    addToLibrary() {
      if (this.selectedVideos.length === 0) {
        this.$message.warning('请先选择视频')
        return
      }

      // 触发父组件事件，传递选中的视频
      this.$emit('add-to-library', this.selectedVideos)

      this.$message.success(`已将 ${this.selectedVideos.length} 个视频发送到素材库`)

      // 清空所有选择
      this.selectedVideoMap.clear()
      this.selectedVideos = []

      // 清除表格中的选中状态
      this.$nextTick(() => {
        if (this.$refs.reportTable) {
          this.$refs.reportTable.clearSelection()
        }
      })
    }
  }
}
</script>

<style scoped>
.video-report-component {
  margin-bottom: 20px;
}

.report-card {
  border-radius: 8px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
}

.header-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.filter-form {
  margin-bottom: 16px;
}

.id-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.id-text {
  font-size: 14px;
  color: #909399;
}

.copy-icon {
  cursor: pointer;
  color: #909399;
  font-size: 14px;
  opacity: 0;
  transition: opacity 0.2s;
}

.id-cell:hover .copy-icon {
  opacity: 1;
}

.copy-icon:hover {
  color: #409eff;
}

.amount-text {
  color: #f56c6c;
  font-weight: 500;
}

.cost-text {
  color: #e6a23c;
  font-weight: 500;
}

.video-preview-cell,
.cover-preview-cell {
  display: flex;
  justify-content: center;
  align-items: center;
}

.no-preview {
  color: #c0c4cc;
  font-size: 12px;
}

.table-actions {
  margin-top: 16px;
  padding: 12px 16px;
  background-color: #f5f7fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* 卡片视图样式 */
.grid-view {
  min-height: 300px;
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  padding: 8px;
}

.video-card {
  position: relative;
  background: #fff;
  border: 2px solid #e4e7ed;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.video-card:hover {
  border-color: #409eff;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
  transform: translateY(-2px);
}

.video-card.selected {
  border-color: #409eff;
  background-color: #ecf5ff;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.card-checkbox {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  padding: 2px;
}

.card-video-preview {
  width: 100%;
  height: 180px;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.card-video-preview video,
.card-video-preview img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.no-preview-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}

.no-preview-placeholder i {
  font-size: 48px;
  margin-bottom: 8px;
}

.missing-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
}

.missing-badge .el-tag {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.card-info {
  padding: 12px;
}

.card-name {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.5;
}

.card-metrics {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.metric-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}

.metric-label {
  color: #909399;
  margin-right: 4px;
}

.metric-value {
  color: #606266;
  font-weight: 500;
}

.metric-value.amount {
  color: #f56c6c;
}

/* 缩略图视图样式 */
.thumbnail-view {
  min-height: 300px;
}

.thumbnail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
  padding: 8px;
}

.thumbnail-item {
  position: relative;
  background: #fff;
  border: 2px solid #e4e7ed;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.thumbnail-item:hover {
  border-color: #409eff;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.25);
  transform: translateY(-3px);
}

.thumbnail-item.selected {
  border-color: #409eff;
  background-color: #ecf5ff;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.thumbnail-item.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  filter: grayscale(50%);
}

.thumbnail-item.disabled:hover {
  border-color: #e4e7ed;
  transform: none;
  box-shadow: none;
}

.thumbnail-checkbox {
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 4px;
  padding: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.thumbnail-missing-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 10;
  background-color: rgba(230, 162, 60, 0.9);
  color: #fff;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.thumbnail-preview {
  position: relative;
  width: 100%;
  height: 140px;
  background-color: #000;
  overflow: hidden;
}

.thumbnail-preview video,
.thumbnail-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.thumbnail-item:hover .thumbnail-preview video,
.thumbnail-item:hover .thumbnail-preview img {
  transform: scale(1.05);
}

.no-thumbnail-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #909399;
  font-size: 40px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e7ed 100%);
}

.play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.thumbnail-item:hover .play-overlay {
  opacity: 1;
}

.play-overlay i {
  font-size: 36px;
  color: #fff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.thumbnail-info {
  padding: 8px 10px;
  background: #fff;
}

.thumbnail-name {
  font-size: 12px;
  color: #303133;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.4;
}

.thumbnail-metrics {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.metric-spend {
  font-size: 13px;
  font-weight: 600;
  color: #f56c6c;
}
</style>